export default class RequestServiceFormFieldType {
    static TEXT = 0;
    static NUMBER = 1;
    static LINK = 2;
    static FILE = 3;
    static SELECT = 4;
    static MULTISELECT = 5;
}
